import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import VisaFormService from "services/VisaFormService";

let initialState = {
    list: [],
};



export const getSmartFormList2 = createAsyncThunk(
    "ownVisaSlice/getSmartFormList2",
    async (body) => {
        const response = await VisaFormService.getSmartserviceList2(body);
        return response?.results;
    }
);



const ownVisaSliceSlice = createSlice({
    name: "ownVisaSlice",
    initialState: initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        LoadingAdapter.applyAsyncBuilder(getSmartFormList2, builder, ["list"]);
    },
});



export default ownVisaSliceSlice.reducer;

